import {mixin, copy, find} from '../../../jsdk';
import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import Product from '../../domain/Product';
import Color from '../../domain/Color';
import User from '../../domain/User';
import SponsorDomain from '../../domain/Sponsor';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import ProductCustomPayments from '../../components/ProductCustomPayments';
import ProductPayments from '../../components/ProductPayments';
import StdTable from '../../components/StdTable';
import DefaultUi from '../../components/DefaultUi';
import CouponContactForm from '../../components/CouponContactForm';
import DomicileContactForm from '../../components/DomicileContactForm';
import InvoiceForm from '../../components/InvoiceForm';
import CouponShipping from '../../components/CouponShipping';
import UserHeader from '../../components/header/User';
import { t, props } from 'tcomb-react';
import ReactSelect from 'react-select';


const CONTACT_FORM_REF = 'ContactForm';

function myRenderSelect(locals) {
  const options = locals.options.filter(o => o.value).map(o => ({value: o.value, label: o.text}));
  function onChange(o) {
    locals.onChange(o ? o.value : '');
  }
  return <ReactSelect options={options} value={locals.value} onChange={onChange} />;
}

@props({
  locale: Locale,
  product: Product,
  user: User,
  sponsor: t.maybe(SponsorDomain),
  order: t.maybe(t.Obj),
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  goApproveOrder: t.Func,
  goProduct: t.Func,
  goAccount: t.Func,
  goPurchases: t.Func,
  goChangePassword: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func,
  partners: t.maybe(t.Obj)
})
export default class BuildOrder extends React.Component {

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getContact() {
    const { locale, user, order, product} = this.props;
    if (this.props.product.is_coupon) {
      return <CouponContactForm locale={locale} user={user} order={order} product={product} ref={CONTACT_FORM_REF} />;
    }
    else {
      return <DomicileContactForm locale={locale} user={user} order={order} product={product} ref={CONTACT_FORM_REF} />;
    }
  }

  getInvoice() {
    if (!this.props.order || !this.props.product.is_invoiced) {
      return null;
    }

    const { locale, user, order, product} = this.props;
    return (<InvoiceForm locale={locale} user={user} order={order} product={product} doShow={!!this.props.order.invoice} ref='InvoiceForm' /> );
  }

  getSummary() {
    const { locale, product } = this.props;
    const order_bundle = get_bundle(locale).order;

    const data = [
      [order_bundle.summary.quantity, '1'],
      [order_bundle.summary.list_price, product.format_amount(locale, product.list_price)],
      [order_bundle.summary.price, product.format_amount(locale, product.runtime.price)],
      [order_bundle.summary.redeemed_value, product.format_amount(locale, product.list_price - product.runtime.price)]
    ];
    return <StdTable>{data}</StdTable>;
  }

  getShippingOptions() {
    const { locale, product } = this.props;
    const omit_country = (product.shipping_countries.length === 1);

    return product.shippings.map(function(shipping) {
      const text = product.display_shipping(locale, shipping, omit_country);
      return {
        value: shipping.id,
        text
      };
    });
  }

  getShippingsEnum() {
    return this.getShippingOptions().map((shipping) => shipping.value);
  };


  getShippingsFormType() {
    const Shippings = t.enums.of(this.getShippingsEnum());
    return t.struct({
      shipping_id: Shippings
    }, 'Shipping');
  }

  onShippingFormChange = (value) => {
    const {product, locale} = this.props;
    const shipping = find(product.shippings, value.shipping_id);
    const cost = shipping ? shipping.cost : 0;
    const total = product.format_amount(locale, product.runtime.price + cost);
    $('#order_total_cost').html(total);
    const country = shipping ? locale.display_country(shipping.country) : '';
    this.refs[CONTACT_FORM_REF].setCountry(country);
  }

  getShippingsFormOptions() {
    return {
      auto: 'none',
      fields: {
        shipping_id: {
          template: myRenderSelect,
          options: this.getShippingOptions()
        }
      }
    };
  }

  hasShipping() {
    return (this.props.order && this.props.order.domicile && this.props.order.domicile.shipping);
  }

  getDefaultShippingValue() {
    if (!this.hasShipping()) {
      return null;
    }
    return this.props.order.domicile.shipping.id;
  }

  getShippingsSection() {
    const { locale, product } = this.props;
    if (product.is_coupon) {
      return (
        <CouponShipping
          locale={locale}
          currency={product.currency} />
      );
    } else if (product.is_coupon || product.shippings.length === 1) {
        return product.display_shippings(locale);
    }
    else {
      const value = {
        shipping_id: this.getDefaultShippingValue()
      };
      return (
        <form>
          <t.form.Form
            ref="ShippingsForm"
            type={this.getShippingsFormType()}
            options={this.getShippingsFormOptions()}
            onChange={this.onShippingFormChange}
            value={value} />
        </form>
      );
    }
  }

  getContactFormValue() {
    if (this.props.product.is_coupon) {
      return this.refs.ContactForm.refs.CouponContactForm.getValue();
    }
    return this.refs.ContactForm.refs.DomicileContactForm.getValue();
  }

  goApproveOrder = (evt) => {
    evt.preventDefault();
    let contactValue = null;
    let invoiceValue = null;
    let shipping_id = null;

    const { product }  = this.props;

    if (!product.is_coupon && product.shippings.length > 1) {
      shipping_id = this.refs.ShippingsForm.getValue().shipping_id;
    }

    contactValue = this.getContactFormValue();

    if (!contactValue) {
      return;
    }

    const contactValueMixed = mixin(copy(contactValue), {shipping_id});

    if (product.is_invoiced && contactValue.go_invoice_form) {
      invoiceValue = this.refs.InvoiceForm.refs.InvoiceForm.getValue();
      if (!invoiceValue) {
        return;
      }
    }
    this.props.goApproveOrder(contactValueMixed, invoiceValue);
  }

  getHeader() {
    return (
      <UserHeader
        locale={this.props.locale}
        goAccount={this.props.goAccount}
        goPurchases={this.props.goPurchases}
        goChangePassword={this.props.goChangePassword}
        doLogout={this.props.doLogout}
        goProduct={this.props.goProduct}
        user={this.props.user}
        color={this.getColor()}
        themeBtnColor={this.props.themeBtnColor}
        themeBtnFontColor={this.props.themeBtnFontColor} />);
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  render() {
    const { locale, product } = this.props;
    const bundle = get_bundle(locale).build_order;
    const order_bundle = get_bundle(locale).order;
    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };

    return (
      <Layout header={this.getHeader()} partners={this.props.partners}  sponsor={this.getSponsor()} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <DefaultUi id="build_order" title={bundle.title} themeBgColor={this.props.themeBgColor} themeBgFontColor={this.props.themeBgFontColor}>
          <div className='cols'>
            <div className='large-40 medium-hide'>
              <div className='cell'>
                <img className="product-image" src={product.image}></img>
                <h3>{bundle.product.payment}</h3>
                <ProductCustomPayments locale={locale} customPayments={this.props.product.custom_payments} />
                <ProductPayments locale={locale} payments={this.props.product.payments} />
              </div>
            </div>
            <div className='large-60 medium-100'>
              <div className='cell'>
                <h2>{product.name}</h2>
                <h3>{order_bundle.summary.title}</h3>
                {this.getSummary()}
                <h3>{order_bundle.shippings.title}</h3>
                {this.getShippingsSection()}
                {/*<Select options={this.getShippingOptions().map(s => ({value: s.value, label: s.text}))} />*/}
                {/*<h3>{order_bundle.summary.total} <span id='order_total_cost'>{product.total(locale)}</span></h3>*/}
                <div className='large-hide medium-show'>
                  <h3>{bundle.product.payment}</h3>
                  <ProductCustomPayments locale={locale} customPayments={this.props.product.custom_payments} />
                  <ProductPayments locale={locale} payments={this.props.product.payments} />
                </div>
                <h3>{order_bundle.domicile.title}</h3>
                {this.getContact()}
                {this.getInvoice()}
                <button id='go_approve_order' className='large-left-30p small-left-0p' onClick={this.goApproveOrder} style={btnStyle}>{bundle.go_approve_order}</button>
              </div>
            </div>
          </div>
        </DefaultUi>
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/BuildOrder.js
 **/